import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=36a94ade&scoped=true&"
import script from "./ViewForm.vue?vue&type=script&lang=js&"
export * from "./ViewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a94ade",
  null
  
)

export default component.exports